import script from "./AddContractAddressModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddContractAddressModal.vue?vue&type=script&setup=true&lang=js"

import "./AddContractAddressModal.vue?vue&type=style&index=0&id=7f9f0703&lang=scss&scoped=true"
script.__scopeId = "data-v-7f9f0703"

export default script